import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { ICommission, ICommissionsQueryParams, IQueryResult } from 'gen/ApiClient';

export const MyQueryContext = React.createContext<IQueryContext<IQueryResult<ICommission>, ICommissionsQueryParams>>(undefined as any);
